import { createScopedLogger } from 'pi-kiosk-shared/logging';
import { customerLogger } from '../logging/customerLogger.js';

export const apiClientLog = createScopedLogger(customerLogger, { module: 'api', feature: 'client' });
